<template>
  <h3 class="h3">Besitzt du bereits einen Führerschein?</h3>
  <RadioMenu v-model="preDriverLicenceRadio" :options="options"/>
  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import RadioMenu from '../../components/RadioMenu.vue'
import { computed } from 'vue';
import { VorauswahlFührerschein, Navigation, DetailStep } from '../../models/enums'
import { useStore } from 'vuex';
import { scrollToTop } from '@/models/helper';

const options = Object.values(VorauswahlFührerschein);
const store = useStore();
const nextDisabled = computed(() => store.state.preDriverLicence == null);

const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  if (store.state.preDriverLicence == VorauswahlFührerschein.JA) {
    store.commit("updateStep", DetailStep.VORAUSWAHL_FÜHRERSCHEIN_DATEN);
  } else {
    store.commit("updateStep", DetailStep.FÜHRERSCHEINKLASSEN);
  }

  scrollToTop();
};

const preDriverLicenceRadio = computed({
  get: () => store.state.preDriverLicence,
  set: value => store.commit("updatePreDriverLicence", value)
});
</script>